import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {GroupHttpService} from "../http/group.http";
import {GroupStore} from "../stores/group.store";
import {GroupResponse} from "../types/group";
import {UserHttpService} from "../http/user.http";
import {UserStore} from "../stores/user.store";
import {UserInfo, UserResponse} from "../types/user";

@Injectable({ providedIn: 'root' })
export class UsersResolver  {
    constructor(private http: UserHttpService, private store: UserStore) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<UserInfo[]> | Promise<UserInfo[]> | UserInfo[] {
        if (this.store.users?.length > 0) {
          return this.store.users;
        }
        return new Promise((resolve, reject) => {
            // get data from route config

            this.http.getAllUsers().subscribe((response) => {
                this.store.users = response.users.map((user) => user.user);
                resolve(this.store.users);
            }, (error) => {
                reject(error);
            });
        });
    }
}
